import { v4 as uuidv4 } from 'uuid';

export function ProductGiftList(props, childrenComponents = []) {
	return {
		componentName: 'ProductGiftList',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		childrenComponents,
	};
}
